/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import useValidateMedia from 'components/hooks/useValidateMedia';
import useHalfSpace from 'components/hooks/useHalfSpace';
import Ad, { ProductRanges, Statuses as AdStatuses } from 'models/business/Ad';
import Asset, { Categories as AssetCategories } from 'models/business/Asset';
import ActionButton from 'components/Common/ActionButton';
import SectionLabel from 'components/pages/ResourceSetting/Widgets/SectionLabel';
import GoogleDisplayReference from 'components/pages/ResourceSetting/Widgets/GoogleDisplayReference';
// import PhonePreview from 'components/pages/ResourceSetting/Widgets/PhonePreview';
import ProductRangeField from 'components/pages/ResourceSetting/Widgets/ProductRangeField';
import HostingUrlField from 'components/pages/ResourceSetting/Widgets/HostingUrlField';
import ShortTitleField from 'components/pages/ResourceSetting/SSCDashboard/ShortTitleField';
import GoogleDescriptionField from 'components/pages/ResourceSetting/Widgets/GoogleDescriptionField';
import SingleImageUploadField from 'components/pages/ResourceSetting/SSCDashboard/SingleImageUploadField';
import SingleFileDrop from 'components/pages/ResourceSetting/SSCDashboard/SingleFileDrop';
import YoutubeUrlField from 'components/pages/ResourceSetting/SSCDashboard/YoutubeUrlField';
import HideableContainer from 'components/Common/HideableContainer';
import SaveChangePopup from 'components/pages/CreateAd/AdSetting/SaveChangePopup';
import ClickableDiv from 'components/Common/ClickableDiv';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import FormBox from 'components/pages/ResourceSetting/Widgets/FormBox';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import API from 'api';
import GoogleUploadSample from 'assets/GoogleUploadSample.png';
import GoogleUploadSample2 from 'assets/GoogleUploadSample2.png';
import ContentFeedField from '../ContentFeedField';
import Styles from './index.module.css';

const EmojiRegex = new RegExp(/[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug);
const useStyles = makeStyles({
  root: {
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
});

export default function MainForm({
  ad,
  onChangeAd,
  // onContinue,
  // eslint-disable-next-line no-unused-vars
  firstEdit,
}) {
  const [productRange, setProductRange] = useState(ProductRanges.Total);
  const [saveChangePopupStatus, setSaveChangePopupStatus] = useState(0);
  const [firstLoad, setFirstLoad] = useState(true);
  const [isAdSaved, setIsAdSaved] = useState(true);
  const classes = useStyles();
  const { validateImage, validateSquareImageRange, validateImageRatioRange } = useValidateMedia();
  const { restrictByHalfSpace, halfSpaceLength } = useHalfSpace();
  const history = useHistory();
  const [popupAction, setPopupAction] = useState();
  const [original, setOriginal] = useState({
    ad: new Ad(),
    shortTitle: [],
    youtubeUrl: [],
    media: {},
    mediaArr: [],
    local: {},
  });
  const [media, setMedia] = useState({
    prepopulated: null,
    local: null,
  });
  const [mediaLogo, setMediaLogo] = useState([]);
  const [mediaNew, setMediaNew] = useState([]);
  const [mediaSquare, setMediaSquare] = useState([]);
  const [mediaStraight, setMediaStraight] = useState([]);
  const [contentFeed, setContentFeed] = useState({
    prepopulated: null,
    local: null,
  });

  const hasUnsavedChanges = useMemo(() => (
    // !original.ad.equals(ad) || original.media !== media || original.contentFeed !== contentFeed || original.mediaArr !== mediaNew;
    !original.ad.equals(ad)
    || !original.shortTitle.every((v, i) => v === ad.shortTitle[i])
    || original.contentFeed !== contentFeed
    || mediaLogo.filter((m) => m?.original !== m?.prepopulated || m?.local).length > 0
    || mediaNew.filter((m) => m?.original !== m?.prepopulated || m?.local).length > 0
    || mediaSquare.filter((m) => m?.original !== m?.prepopulated || m?.local).length > 0
    || mediaStraight.filter((m) => m?.original !== m?.prepopulated || m?.local).length > 0
    || !original.youtubeUrl.every((v, i) => v === ad.youtubeUrl[i])
  ), [ad, original, media, contentFeed, mediaLogo, mediaNew, mediaSquare, mediaStraight]);

  const deleteAllMedia = async (categories = [AssetCategories.Media, AssetCategories.ContentFeed]) => {
    const deletionPromises = [];
    ad.assets.forEach((asset) => {
      if (categories.includes(asset.category)) {
        deletionPromises.push(API.ad.deleteAdMedia(asset.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  const deleteAllMediaLogo = async () => {
    const deletionPromises = [];
    mediaLogo.forEach((object) => {
      if (object.original !== null && object.original !== object.prepopulated) {
        deletionPromises.push(API.ad.deleteAdMedia(object.original.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  const deleteAllMediaNew = async () => {
    const deletionPromises = [];
    mediaNew.forEach((object) => {
      if (object.original !== null && object.original !== object.prepopulated) {
        deletionPromises.push(API.ad.deleteAdMedia(object.original.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  const deleteAllMediaSquare = async () => {
    const deletionPromises = [];
    mediaSquare.forEach((object) => {
      if (object.original !== null && object.original !== object.prepopulated) {
        deletionPromises.push(API.ad.deleteAdMedia(object.original.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  const deleteAllMediaStraight = async () => {
    const deletionPromises = [];
    mediaStraight.forEach((object) => {
      if (object.original !== null && object.original !== object.prepopulated) {
        deletionPromises.push(API.ad.deleteAdMedia(object.original.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  const uploadFile = async (file, category) => API.ad.postAdMedia(ad.id, category, file);

  const filterEgregious = (s) => {
    const ss = s.replace(EmojiRegex, '');
    let newString = '';
    let hasExclamation = false;
    for (let i = 0; i < ss.length; i += 1) {
      const c = ss[i];
      if (c === '!' || c === '！') {
        // eslint-disable-next-line no-continue
        if (hasExclamation) continue;
        hasExclamation = true;
      }
      newString += c;
    }
    return newString;
  };

  const handleChangeField = (e, field, length) => {
    const newAd = ad.clone();
    if (halfSpaceLength(e.target.value) > length) {
      alert(`輸入文字超過長度上限(${length})`);
    }
    const value = length ? restrictByHalfSpace(filterEgregious(e.target.value), length, newAd[field]) : e.target.value;
    newAd[field] = value;
    onChangeAd(newAd);
  };

  const handleChangeArrayField = (e, field, idx, length) => {
    const newAd = ad.clone();
    if (halfSpaceLength(e.target.value) > length) {
      alert(`輸入文字超過長度上限(${length})`);
    }
    const value = length ? restrictByHalfSpace(filterEgregious(e.target.value), length, newAd[field][idx]) : e.target.value;
    // if (newAd[field].filter((a) => a === value).length) {
    //   alert('有重複的廣告標題，請輸入不同的廣告標題');
    // }
    newAd[field][idx] = value;
    onChangeAd(newAd);
  };

  const validAllMedia = async () => {
    let valid = true;

    if (mediaLogo.length === 0 || mediaNew.length === 0 || mediaSquare.length === 0) {
      valid = false;
    }

    return valid;
  };

  const saveAd = async () => {
    if (!hasUnsavedChanges) return true;
    setIsAdSaved(false);
    let newOriginalMedia = original.media;
    let newOriginalContent = original.contentFeed;
    const clearAdAssets = (categories = []) => {
      if (categories.includes(AssetCategories.Media)) {
        const newMedia = {
          prepopulated: null,
          local: null,
        };
        setMedia(newMedia);
        newOriginalMedia = newMedia;
      }
      if (categories.includes(AssetCategories.ContentFeed)) {
        const newContentFeed = {
          prepopulated: null,
          local: null,
        };
        setContentFeed(newContentFeed);
        newOriginalContent = newContentFeed;
      }
      const newAd = ad.clone();
      newAd.assets = [...newAd.assets].filter((a) => !categories.includes(a));
      onChangeAd(newAd);
      return newAd;
    };

    const deletionCategories = [];
    // if (!media.prepopulated) deletionCategories.push(AssetCategories.Media);
    if (!contentFeed.prepopulated || productRange === ProductRanges.Total) deletionCategories.push(AssetCategories.ContentFeed);
    await deleteAllMedia(deletionCategories);
    await deleteAllMediaLogo();
    await deleteAllMediaNew();
    await deleteAllMediaSquare();
    await deleteAllMediaStraight();

    const localDeletionCategories = [];
    // if (!media.local && !media.prepopulated) localDeletionCategories.push(AssetCategories.Media);
    if ((!contentFeed.local && !contentFeed.prepopulated) || ad.contentFeedCategory === AssetCategories.MarketContentFeed) localDeletionCategories.push(AssetCategories.ContentFeed);
    const newAd = clearAdAssets(localDeletionCategories);

    const newAssets = [];

    // if (media.local) {
    //   const result = await uploadFile(media.local, AssetCategories.Media);
    //   if (!result.error) {
    //     const newMedia = {
    //       prepopulated: new Asset(result.resultData),
    //       local: null,
    //     };
    //     setMedia(newMedia);
    //     newOriginalMedia = newMedia;
    //     newAssets.push(new Asset(result.resultData));
    //   }
    // } else if (media.prepopulated) {
    //   newAssets.push(new Asset(media.prepopulated));
    // }

    mediaLogo.forEach(async (object) => {
      if (object.local) {
        const result = await uploadFile(object.local, AssetCategories.MediaLogo);
        if (!result.error) {
          const data = new Asset(result.resultData);
          object.original = data;
          object.prepopulated = data;
          object.local = null;
          newAssets.push(new Asset(result.resultData));
        }
      } else if (object.prepopulated) {
        newAssets.push(new Asset(object.prepopulated));
      }
    });

    mediaNew.forEach(async (object) => {
      if (object.local) {
        const result = await uploadFile(object.local, AssetCategories.Media);
        if (!result.error) {
          const data = new Asset(result.resultData);
          object.original = data;
          object.prepopulated = data;
          object.local = null;
          newAssets.push(new Asset(result.resultData));
        }
      } else if (object.prepopulated) {
        newAssets.push(new Asset(object.prepopulated));
      }
    });

    mediaSquare.forEach(async (object) => {
      if (object.local) {
        const result = await uploadFile(object.local, AssetCategories.MediaSquare);
        if (!result.error) {
          const data = new Asset(result.resultData);
          object.original = data;
          object.prepopulated = data;
          object.local = null;
          newAssets.push(new Asset(result.resultData));
        }
      } else if (object.prepopulated) {
        newAssets.push(new Asset(object.prepopulated));
      }
    });

    mediaStraight.forEach(async (object) => {
      if (object.local) {
        const result = await uploadFile(object.local, AssetCategories.MediaStraight);
        if (!result.error) {
          const data = new Asset(result.resultData);
          object.original = data;
          object.prepopulated = data;
          object.local = null;
          newAssets.push(new Asset(result.resultData));
        }
      } else if (object.prepopulated) {
        newAssets.push(new Asset(object.prepopulated));
      }
    });

    if (contentFeed.local) {
      const result = await uploadFile(contentFeed.local, AssetCategories.ContentFeed);
      if (!result.error) {
        const newContentFeed = {
          prepopulated: new Asset(result.resultData),
          local: null,
        };
        setContentFeed(newContentFeed);
        newOriginalContent = newContentFeed;
        newAssets.push(new Asset(result.resultData));
      }
    } else if (contentFeed.prepopulated && ad.contentFeedCategory !== AssetCategories.MarketContentFeed) {
      newAssets.push(new Asset(contentFeed.prepopulated));
    }

    // const newAd = ad.clone();
    const preStatus = newAd.status;
    newAd.status = AdStatuses.Incomplete;

    newAd.injectAssets(newAssets);
    onChangeAd(newAd);

    // const result = await API.ad.postUpdateAd(newAd.toJSON());
    const result = await API.ad.postUpdateAd2(newAd.toJSON());
    if (result.error) {
      alert(result.error.errorMsg);
      setIsAdSaved(true);
      return null;
    }
    setOriginal({
      ad: newAd,
      shortTitle: newAd.shortTitle,
      youtubeUrl: newAd.youtubeUrl,
      media: newOriginalMedia,
      contentFeed: newOriginalContent,
    });
    setIsAdSaved(true);
    if (ad.valid
      && (mediaLogo.filter((m) => m?.prepopulated || m?.local).length > 0)
      && (mediaNew.filter((m) => m?.prepopulated || m?.local).length > 0)
      && (mediaSquare.filter((m) => m?.prepopulated || m?.local).length > 0)
      && !(ad.contentFeedCategory === AssetCategories.ContentFeed && !(contentFeed.local || contentFeed.prepopulated))
    ) {
      if (preStatus === AdStatuses.Incomplete) {
        setSaveChangePopupStatus(0);
      }
      if (preStatus === AdStatuses.Pending || preStatus === AdStatuses.Online) {
        setSaveChangePopupStatus(2);
      }
      setPopupAction(true);
    } else if (preStatus === AdStatuses.Pending || preStatus === AdStatuses.Online) {
      setSaveChangePopupStatus(1);
      setPopupAction(true);
    }
    return true;
  };

  const submitAd = async () => {
    // setPopupAction(true);
    // saveAd().then((ok) => ok && popupAction && history.push('/MyAds'));
    // saveAd().then((ok) => ok && history.push('/MyAds'));
    saveAd().then((ok) => ok);
  };

  useEffect(() => {
    if (!firstLoad || !ad.id) return;
    setFirstLoad(false);

    for (let i = ad.shortTitle.length; i < 3; i += 1) {
      ad.shortTitle.push('');
    }

    for (let i = ad.youtubeUrl.length; i < 5; i += 1) {
      ad.youtubeUrl.push('');
    }

    const originalAd = ad;
    let originalMedia = media;
    let originalContent = contentFeed;
    const mediaAsset = ad.assets.find((a) => a.category === AssetCategories.Media);
    const mediaAsset1 = ad.assets.filter((a) => a.category === AssetCategories.Media);
    mediaAsset1.forEach((object) => {
      const newData = {
        original: object,
        prepopulated: object,
        local: null,
      };
      mediaNew.push(newData);
    });

    for (let i = mediaAsset1.length; i < 5; i += 1) {
      const newData = {
        original: null,
        prepopulated: null,
        local: null,
      };
      mediaNew.push(newData);
    }
    setMediaNew((result) => [...result]);
    const originalMediaArr = mediaNew;

    const mediaAssetLogo = ad.assets.filter((a) => a.category === AssetCategories.MediaLogo);
    mediaAssetLogo.forEach((object) => {
      const newData = {
        original: object,
        prepopulated: object,
        local: null,
      };
      mediaLogo.push(newData);
    });
    for (let i = mediaAssetLogo.length; i < 5; i += 1) {
      const newData = {
        original: null,
        prepopulated: null,
        local: null,
      };
      mediaLogo.push(newData);
    }
    setMediaLogo((result) => [...result]);

    const mediaAssetSquare = ad.assets.filter((a) => a.category === AssetCategories.MediaSquare);
    mediaAssetSquare.forEach((object) => {
      const newData = {
        original: object,
        prepopulated: object,
        local: null,
      };
      mediaSquare.push(newData);
    });
    for (let i = mediaAssetSquare.length; i < 5; i += 1) {
      const newData = {
        original: null,
        prepopulated: null,
        local: null,
      };
      mediaSquare.push(newData);
    }
    setMediaSquare((result) => [...result]);

    const mediaAssetStraight = ad.assets.filter((a) => a.category === AssetCategories.MediaStraight);
    mediaAssetStraight.forEach((object) => {
      const newData = {
        original: object,
        prepopulated: object,
        local: null,
      };
      mediaStraight.push(newData);
    });
    for (let i = mediaAssetStraight.length; i < 5; i += 1) {
      const newData = {
        original: null,
        prepopulated: null,
        local: null,
      };
      mediaStraight.push(newData);
    }
    setMediaStraight((result) => [...result]);

    if (mediaAsset) {
      const newMedia = {
        prepopulated: mediaAsset,
        local: null,
      };
      setMedia(newMedia);
      originalMedia = newMedia;
    }
    const contentAsset = ad.assets.find((a) => a.category === AssetCategories.ContentFeed);
    if (contentAsset) {
      const newContentFeed = {
        prepopulated: contentAsset,
        local: null,
      };
      setContentFeed(newContentFeed);
      originalContent = newContentFeed;
      setProductRange(ProductRanges.Selected);
    }
    setOriginal({
      ad: originalAd,
      shortTitle: originalAd.shortTitle.slice(),
      youtubeUrl: originalAd.youtubeUrl.slice(),
      media: originalMedia,
      mediaArr: originalMediaArr,
      contentFeed: originalContent,
    });
  }, [ad]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{ position: 'relative' }}
    >
      <Box marginBottom={5}>
        <Box marginBottom={2}>
          <SectionLabel>各種版位一次滿足全方位銷售產品</SectionLabel>
        </Box>
        <GoogleDisplayReference />
      </Box>
      {/* <SectionLabel>PMAX 素材設定</SectionLabel> */}
      {/* <div className={Styles.phonePreviewContainer}>
        <PhonePreview className={Styles.phonePreview} />
      </div> */}
      <Box marginBottom={3}>
        <FormLabel
          title="廣告標題"
          description="長度上限為30個半形文字，請勿輸入表情符號"
          example="https://www.hhgalaxy.com.tw/qa/87#339"
          disabled={false}
          required={true}
        />
        <ShortTitleField value={ad.shortTitle[0]} onChange={(e) => handleChangeArrayField(e, 'shortTitle', 0, 30)} />
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div className={classNames(Styles.alertTextDuplicate)}>
            {`${(ad.shortTitle.filter((a) => a.length > 0 && a === ad.shortTitle[0]).length > 1 ? '廣告標題重複，請輸入不同的廣告標題' : '')}`}
          </div>
          <div className={classNames(Styles.cntTextLength)}>
            {`${halfSpaceLength(ad.shortTitle[0])} / 30`}
          </div>
        </div>
        <ShortTitleField value={ad.shortTitle[1]} onChange={(e) => handleChangeArrayField(e, 'shortTitle', 1, 30)} />
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div className={classNames(Styles.alertTextDuplicate)}>
            {`${(ad.shortTitle.filter((a) => a.length > 0 && a === ad.shortTitle[1]).length > 1 ? '廣告標題重複，請輸入不同的廣告標題' : '')}`}
          </div>
          <div className={classNames(Styles.cntTextLength)}>
            {`${halfSpaceLength(ad.shortTitle[1])} / 30`}
          </div>
        </div>
        <ShortTitleField value={ad.shortTitle[2]} onChange={(e) => handleChangeArrayField(e, 'shortTitle', 2, 30)} />
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div className={classNames(Styles.alertTextDuplicate)}>
            {`${(ad.shortTitle.filter((a) => a.length > 0 && a === ad.shortTitle[2]).length > 1 ? '廣告標題重複，請輸入不同的廣告標題' : '')}`}
          </div>
          <div className={classNames(Styles.cntTextLength)}>
            {`${halfSpaceLength(ad.shortTitle[2])} / 30`}
          </div>
        </div>
      </Box>
      <Box marginBottom={3}>
        <GoogleDescriptionField value={ad.googleDescription} onChange={(e) => handleChangeField(e, 'googleDescription', 90)} />
        <div className={classNames(Styles.cntTextLength)}>
          {`${halfSpaceLength(ad.googleDescription)} / 90`}
        </div>
      </Box>
      <Box marginBottom={3}>
        <FormLabel
          title="說明"
          description="長度上限為60個半形文字，請勿輸入表情符號"
          disabled={false}
          required={true}
        />
        <ShortTitleField value={ad.googleNote} onChange={(e) => handleChangeField(e, 'googleNote', 60)} />
        <div className={classNames(Styles.cntTextLength)}>
          {`${halfSpaceLength(ad.googleNote)} / 60`}
        </div>
      </Box>
      <Box marginBottom={3}>
        {/* <FormLabel
          title="品牌標誌上傳"
          disabled={false}
          required={true}
        /> */}
        <Accordion
          m={1}
          classes={{ root: classes.root }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {/* <Typography>像素限制1:1，最小128X128，最大1200*1200 至少上傳一張</Typography> */}
            <label className={classNames(Styles.title, Styles.required)}>
              品牌標誌上傳(檔案上限5MB)
            </label>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            <label className={classNames(Styles.description)}>
              品牌Logo(1:1)
              <font color="red">*必填</font>
              ，像素限制128x128~1200x1200
            </label>
            <br />
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div style={{ margin: '5px', width: '150px' }}>
                <label className={classNames(Styles.description)}>
                  範例：
                </label>
                <img src={GoogleUploadSample} alt="GoogleUploadSample" style={{ maxWidth: '70%' }} />
              </div>
              {mediaLogo.slice(0, 4).map((object) => (
                <div style={{ margin: '5px', width: '150px' }}>
                  {/* <SingleImageUploadField
                    value={(object?.local ?? object?.prepopulated ?? {}).name}
                    onChange={async (file) => {
                      if (file) {
                        const valid = await validateSquareImageRange(file, 128, 1200);
                        if (!valid) return;
                      }
                      object.prepopulated = null;
                      object.local = file;
                      setMediaLogo((result) => [...result]);
                    }}
                  />
                  <br /> */}
                  {/* <FormFileDrop
                    onSelectFile={async (files) => {
                      if (files[0]) {
                        // const name = (files[0].name || '').toLowerCase();
                        // const allowedExtensions = ['.csv', '.xlsx', '.xls', '.numbers'];
                        // let allowed = false;
                        // for (let i = 0; i < allowedExtensions.length && !allowed; i += 1) {
                        //   if (name.endsWith(allowedExtensions[i])) allowed = true;
                        // }
                        // if (!allowed) return;
                        const valid = await validateSquareImageRange(files[0], 128, 1200);
                        if (!valid) return;

                        object.prepopulated = null;
                        object.local = files[0];
                        setMediaLogo((result) => [...result]);
                      }
                      // onChange(files[0]);
                    }}
                    selectedFilename={(object?.local ?? object?.prepopulated ?? {}).name}
                    title=""
                    description=""
                  /> */}
                  <SingleFileDrop
                    value={(object?.local ?? object?.prepopulated ?? {}).name}
                    onChange={async (file) => {
                      if (file) {
                        const valid = await validateSquareImageRange(file, 128, 1200, undefined, 5 * 1024 * 1024);
                        if (!valid) return;
                      }
                      object.prepopulated = null;
                      object.local = file;
                      setMediaLogo((result) => [...result]);
                    }}
                  />
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box marginBottom={3}>
        {/* <SingleImageUploadField
          value={(media.local ?? media.prepopulated ?? {}).name}
          onChange={async (file) => {
            if (file) {
              const valid = await validateImage(file, 1200, 628);
              if (!valid) return;
            }
            setMedia({
              prepopulated: null,
              local: file,
            });
          }}
        /> */}
        {/* <FormLabel
          title="長方形圖片上傳"
          disabled={false}
          required={true}
        /> */}
        <Accordion
          m={1}
          classes={{ root: classes.root }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {/* <Typography>長方形圖片，像素限制1200X628 至少上傳一張</Typography> */}
            <label className={classNames(Styles.title, Styles.required)}>
              圖片素材上傳(檔案上限5MB)
            </label>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            <div style={{ display: 'flex' }}>
              <img src={GoogleUploadSample2} alt="GoogleUploadSample2" style={{ maxWidth: '100%' }} />
            </div>
            <br />
            <label className={classNames(Styles.description)}>
              橫向圖片(1.91:1)
              <font color="red">*必填</font>
              ，像素限制1200x628、2400x1256
            </label>
            <br />
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {mediaNew.map((object) => (
                // <>
                //   <SingleImageUploadField
                //     value={(object?.local ?? object?.prepopulated ?? {}).name}
                //     onChange={async (file) => {
                //       if (file) {
                //         const valid = await validateImage(file, 1200, 628);
                //         if (!valid) return;
                //       }
                //       object.prepopulated = null;
                //       object.local = file;
                //       setMediaNew((result) => [...result]);
                //     }}
                //   />
                //   <br />
                // </>
                <div style={{ margin: '5px', width: '150px' }}>
                  <SingleFileDrop
                    value={(object?.local ?? object?.prepopulated ?? {}).name}
                    onChange={async (file) => {
                      if (file) {
                        let valid = await validateImage(file, 1200, 628, false, 5 * 1024 * 1024);
                        if (!valid) valid = await validateImage(file, 2400, 1256, false, 5 * 1024 * 1024);
                        if (!valid) {
                          alert('您上傳的檔案不符合比例(1.91:1)，像素限制1200x628、2400x1256格式及檔案大小5MB，請重新上傳');
                          return;
                        }
                      }
                      object.prepopulated = null;
                      object.local = file;
                      setMediaNew((result) => [...result]);
                    }}
                  />
                </div>
              ))}
            </div>
            <br />
            <label className={classNames(Styles.description)}>
              正方形圖片(1:1)
              <font color="red">*必填</font>
              ，像素限制1080x1080~2400x2400
            </label>
            <br />
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {mediaSquare.map((object) => (
                // <>
                //   <SingleImageUploadField
                //     value={(object?.local ?? object?.prepopulated ?? {}).name}
                //     onChange={async (file) => {
                //       if (file) {
                //         const valid = await validateImage(file, 1200, 1200);
                //         if (!valid) return;
                //       }
                //       object.prepopulated = null;
                //       object.local = file;
                //       setMediaSquare((result) => [...result]);
                //     }}
                //   />
                //   <br />
                // </>
                <div style={{ margin: '5px', width: '150px' }}>
                  <SingleFileDrop
                    value={(object?.local ?? object?.prepopulated ?? {}).name}
                    onChange={async (file) => {
                      if (file) {
                        const valid = await validateSquareImageRange(file, 1080, 2400, undefined, 5 * 1024 * 1024);
                        if (!valid) return;
                      }
                      object.prepopulated = null;
                      object.local = file;
                      setMediaSquare((result) => [...result]);
                    }}
                  />
                </div>
              ))}
            </div>
            <br />
            <label className={classNames(Styles.description)}>
              直向圖片(4:5)(選填)，像素限制960x1200
            </label>
            <br />
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {mediaStraight.map((object) => (
                <div style={{ margin: '5px', width: '150px' }}>
                  <SingleFileDrop
                    value={(object?.local ?? object?.prepopulated ?? {}).name}
                    onChange={async (file) => {
                      if (file) {
                        const valid = await validateImage(file, 960, 1200, undefined, 5 * 1024 * 1024);
                        if (!valid) return;
                      }
                      object.prepopulated = null;
                      object.local = file;
                      setMediaStraight((result) => [...result]);
                    }}
                  />
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </Box>
      {/* <Box marginBottom={3}>
        <FormLabel
          title="正方形圖片上傳"
          disabled={false}
          required={true}
        />
        <Accordion
          m={1}
          classes={{ root: classes.root }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>正方形圖片，像素限制1200X1200 至少上傳一張</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            {mediaSquare.map((object) => (
              <>
                <SingleImageUploadField
                  value={(object?.local ?? object?.prepopulated ?? {}).name}
                  onChange={async (file) => {
                    if (file) {
                      const valid = await validateImage(file, 1200, 1200);
                      if (!valid) return;
                    }
                    object.prepopulated = null;
                    object.local = file;
                    setMediaSquare((result) => [...result]);
                  }}
                />
                <br />
              </>
            ))}
          </AccordionDetails>
        </Accordion>
      </Box> */}
      <Box marginBottom={3}>
        {/* <FormLabel
          title="影片連結"
          disabled={false}
          required={true}
        /> */}
        <Accordion
          m={1}
          classes={{ root: classes.root }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {/* <Typography>須是YouTube網址，影片長度建議15~30秒，最多五組</Typography> */}
            <label className={classNames(Styles.title)}>
              影片素材連結
            </label>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            <label className={classNames(Styles.description)}>
              須是YouTube網址，影片長度建議15~30秒，最多五組
            </label>
            <br />
            <YoutubeUrlField value={ad.youtubeUrl[0]} onChange={(e) => handleChangeArrayField(e, 'youtubeUrl', 0)} />
            <br />
            <YoutubeUrlField value={ad.youtubeUrl[1]} onChange={(e) => handleChangeArrayField(e, 'youtubeUrl', 1)} />
            <br />
            <YoutubeUrlField value={ad.youtubeUrl[2]} onChange={(e) => handleChangeArrayField(e, 'youtubeUrl', 2)} />
            <br />
            <YoutubeUrlField value={ad.youtubeUrl[3]} onChange={(e) => handleChangeArrayField(e, 'youtubeUrl', 3)} />
            <br />
            <YoutubeUrlField value={ad.youtubeUrl[4]} onChange={(e) => handleChangeArrayField(e, 'youtubeUrl', 4)} />
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box marginBottom={3}>
        <HostingUrlField required={true} value={ad.hostingUrl} onChange={(e) => handleChangeField(e, 'hostingUrl')} />
      </Box>
      <Box marginBottom={3}>
        <ProductRangeField
          value={productRange}
          onChange={(range) => {
            let newContentFeedCategory = AssetCategories.ContentFeed;
            if (range === ProductRanges.Total) {
              newContentFeedCategory = AssetCategories.MarketContentFeed;
            }
            setProductRange(range);

            const newAd = ad.clone();
            newAd.contentFeedCategory = newContentFeedCategory;
            onChangeAd(newAd);
          }}
          contentFeed={contentFeed}
          setContentFeed={() => setContentFeed({
            prepopulated: null,
            local: null,
          })}
        />
      </Box>
      <HideableContainer hidden={productRange !== ProductRanges.Selected}>
        <Box marginBottom={3}>
          <ContentFeedField
            value={(contentFeed.local ?? contentFeed.prepopulated ?? {}).name}
            onChange={(file) => {
              setContentFeed({
                prepopulated: null,
                local: file,
              });
            }}
          />
        </Box>
      </HideableContainer>
      <div className={Styles.formButtons}>
        <ActionButton
          style={{ color: '#FFFFFF' }}
          onClick={(e) => {
            // e.target.setAttribute('disabled', true);
            saveAd();
          }}
          disabled={!hasUnsavedChanges}
        >
          儲存進度
        </ActionButton>
        <ActionButton style={{ color: '#FFFFFF' }} onClick={() => history.push('/MyAds')}>
          {firstEdit ? '返回我的廣告' : '取消'}
          {/* 取消 */}
        </ActionButton>
        <ActionButton
          style={{ color: '#FFFFFF' }}
          disabled={(
            !isAdSaved
            || !ad.valid
            // || !(media.prepopulated || media.local)
            // || !(mediaLogo.length === 0 || mediaNew.length === 0 || mediaSquare.length === 0)
            || (mediaLogo.filter((m) => m?.prepopulated || m?.local).length === 0)
            || (mediaNew.filter((m) => m?.prepopulated || m?.local).length === 0)
            || (mediaSquare.filter((m) => m?.prepopulated || m?.local).length === 0)
            || (ad.contentFeedCategory === AssetCategories.ContentFeed && !(contentFeed.local || contentFeed.prepopulated))
          )}
          onClick={submitAd}
        >
          完成
        </ActionButton>
        {/* {popupAction && <SaveChangePopup onClose={() => { setPopupAction(); submitAd(); }} />} */}
        {popupAction && <SaveChangePopup status={saveChangePopupStatus} onClose={() => { setPopupAction(); history.push('/MyAds'); }} />}
      </div>
    </Box>
  );
}

MainForm.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  // onContinue: PropTypes.func,
  firstEdit: PropTypes.bool,
};

MainForm.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
  // onContinue: () => {},
  firstEdit: false,
};
